import { useState, useRef, useEffect, useLayoutEffect, PureComponent, memo } from 'react';
import debounce from 'react-utils/debounce';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { DragSource } from 'react-dnd';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { getEmptyImage } from 'react-dnd-html5-backend';
import { DRAG_TYPE, getMaxEditorHeight, minEditorHeight, RESIZABLE_REPLY_EDITOR_ID } from './ResizableThreadViewWrapper';
import styled, { css } from 'styled-components';
import ResizableDragHandle from './ResizableDragHandle';
import { replyEditorResized } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { useLocalStorage } from '../../../local-storage/hooks/useLocalStorage';
import { USER_DEFINED_EDITOR_HEIGHT_PERCENTAGE } from '../constants/resizableReplyEditorConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ComposerHeightWrapper = styled.div.withConfig({
  displayName: "ResizableStyling__ComposerHeightWrapper",
  componentId: "adf2ub-0"
})(["display:flex;flex-direction:column;position:relative;max-height:100%;", ";"], ({
  height
}) => height ? `height: ${height}px` : '');
class HeightWrapperWithDragHandle extends PureComponent {
  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage());
  }
  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showDragBar' does not exist on type 'Rea... Remove this comment to see the full error message
      showDragBar,
      height,
      connectDragSource,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
      disabled
    } = this.props;
    const heightProp = disabled ? {
      height: 50
    } : height ? {
      height
    } : {};
    return /*#__PURE__*/_jsxs(ComposerHeightWrapper, Object.assign({}, heightProp, {
      children: [!disabled && /*#__PURE__*/_jsx(ResizableDragHandle, {
        ref: instance => connectDragSource(instance)
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ ref: (instance: unknown) => any; hide: boo... Remove this comment to see the full error message
        ,
        hide: !showDragBar
      }), this.props.children]
    }));
  }
}
HeightWrapperWithDragHandle.displayName = 'ReplyEditorWithDragHandle';
const dragSourceConfig = {
  beginDrag: ({
    onDragStart,
    height,
    setHeight,
    boundingRef
  }) => {
    onDragStart();
    const boundingHeight = boundingRef.current && boundingRef.current.getBoundingClientRect().height;
    return {
      height: height || boundingHeight,
      setHeight,
      id: RESIZABLE_REPLY_EDITOR_ID
    };
  },
  endDrag: ({
    onDragEnd
  }) => {
    onDragEnd();
  }
};
const collect = connectDrag => {
  return {
    connectDragSource: connectDrag.dragSource(),
    connectDragPreview: connectDrag.dragPreview()
  };
};
const ConnectedHeightWrapperWithDragHandle = DragSource(DRAG_TYPE, dragSourceConfig, collect)(HeightWrapperWithDragHandle);

// Draft editor overrides to fill available space
const DraftStylingWrapper = styled.div.withConfig({
  displayName: "ResizableStyling__DraftStylingWrapper",
  componentId: "adf2ub-1"
})(["max-height:", ";&&&{", "}"], ({
  maxHeight
}) => `${maxHeight}px`, ({
  height
}) => {
  if (height) {
    return css([".DraftEditor-root{max-height:none;flex-shrink:1;flex-basis:0;}.DraftEditor-editorContainer{height:100%;}.TabbedEditorPositionWrapper{flex-shrink:1;}.draft-extend-editor{flex-shrink:1;}"]);
  }
  return '';
});
const ResizableStyling = /*#__PURE__*/memo(props => {
  const {
    threadId,
    editorFragment,
    trackEvent
  } = props;
  // the drag event can sometimes leave a hover state on the element,
  //  so we explicitly hide this drag bar rather than relying solely
  // on the hover state
  const [showDragBar, setShowDragBar] = useState(true);

  // Use localStorage to store the user preferred height for each
  // of the editory type
  const [userEditorHeight, setUserEditorHeight] = useLocalStorage({
    key: USER_DEFINED_EDITOR_HEIGHT_PERCENTAGE,
    initialValue: JSON.stringify({})
  });
  const [height, setHeight] = useState(undefined);
  const [percentForThreadId, setPercentForThreadId] = useState({});
  const boundingRef = useRef();
  useLayoutEffect(() => {
    const adjustHeightByChannel = () => {
      const windowHeight = window.innerHeight;
      try {
        // Check if user preferred height exists for the current editor
        // fragment and use it to calculate the pixel height
        const percent = JSON.parse(userEditorHeight)[editorFragment];
        if (percent) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
          setHeight(windowHeight * percent);
        } else {
          setHeight(undefined);
        }
        // store the threadId and currently applied percentage of height for
        // later use in case the user resizes the window or there is a channel
        // switch
        setPercentForThreadId(prevState => Object.assign({}, prevState, {
          threadId,
          percent
        }));
      } catch (e) {
        // in case of error don't set the height
        setHeight(undefined);
      }
    };
    if (editorFragment && threadId !== percentForThreadId.threadId) {
      adjustHeightByChannel();
    }
  }, [threadId, editorFragment, userEditorHeight, percentForThreadId]);
  useEffect(() => {
    const resize = () => {
      setHeight(
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      window.innerHeight * percentForThreadId.percent);
    };
    const debouncedResize = debounce(resize, 300);
    window.addEventListener('resize', debouncedResize);
    return () => {
      window.removeEventListener('resize', debouncedResize);
    };
  });

  // maybe add some reporting here for usage data
  const onResizeEnd = newHeight => {
    setHeight(newHeight);
    setShowDragBar(true);
    try {
      // set the new editor height to the local storage
      // so we can use the percentage to set it automatically for other
      // threads with same editor type
      const percent = newHeight / window.innerHeight;
      setUserEditorHeight(JSON.stringify(Object.assign({}, JSON.parse(userEditorHeight), {
        [editorFragment]: percent
      })));
      setPercentForThreadId(prevState => Object.assign({}, prevState, {
        threadId,
        percent
      }));
    } catch (e) {
      // do nothing
    }
    trackEvent(replyEditorResized({
      newHeight,
      windowHeight: window.innerHeight
    }));
  };
  const onDragEnd = () => {
    setShowDragBar(true);
  };
  const onDragStart = () => {
    setShowDragBar(false);
  };
  const boundedHeight = Math.min(getMaxEditorHeight(),
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
  Math.max(minEditorHeight, height));
  return /*#__PURE__*/_jsx(DraftStylingWrapper, {
    maxHeight: getMaxEditorHeight(),
    height: height
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    ,
    ref: boundingRef,
    "data-test-id": "resizable-reply-wrapper",
    children: /*#__PURE__*/_jsx(ConnectedHeightWrapperWithDragHandle, {
      height: boundedHeight,
      setHeight: onResizeEnd,
      boundingRef: boundingRef,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      showDragBar: showDragBar,
      children: props.children
    })
  });
});
ResizableStyling.displayName = 'ResizableStyling';
export default ResizableStyling;